import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GenericButton from './GenericButton';
import { CODING_BOX_ADVANCED_BUTTON_CLICK } from '../../constants';

export default class ExpressionCreatorBtnDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = { isVisible: false };
  }

  show = () => {
    this.props.trackerFn({ action: CODING_BOX_ADVANCED_BUTTON_CLICK });
    this.setState({ isVisible: true });
    document.addEventListener('click', this.hide);
  };

  hide = () => {
    this.setState({ isVisible: false });
    document.removeEventListener('click', this.hide);
  };

  renderDropDown = () =>
    this.props.dropdownOptions.map(dropdownOption => (
      <GenericButton
        key={dropdownOption.name}
        name={dropdownOption.name}
        onBtnClick={() => {
          this.show();
          dropdownOption.onDropDownOptionClick();
        }}
      />
    ));

  render() {
    return (
      <div className={'more-dropdown'}>
        <GenericButton
          name={this.props.dropDownText}
          btnStyle="button more-button clearfix"
          onBtnClick={this.show}
          btnDisabled={this.props.btnDisabled}
        />
        <div
          className={
            this.state.isVisible
              ? 'dropdown-pane-custom top'
              : 'dropdown-pane top showComponent'
          }
          data-dropdown
        >
          <div className="button-list">{this.renderDropDown()}</div>
        </div>
      </div>
    );
  }
}

ExpressionCreatorBtnDropdown.propTypes = {
  dropdownOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  btnDisabled: PropTypes.bool,
  dropDownText: PropTypes.string,
  trackerFn: PropTypes.func,
};

ExpressionCreatorBtnDropdown.defaultProps = {
  dropDownText: 'More',
};
